import $ from 'jquery';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import focus from '@alpinejs/focus';
import ui from '@alpinejs/ui';
import persist from '@alpinejs/persist';
import Alpine from 'alpinejs';
import gallery from './blocks/core/gallery';
import header from './components/header';
import modal from './components/modal';
import { select } from './components/select';
import accordionImages from './blocks/acf/accordionImages';
import contactPeople from './blocks/acf/contactPeople';
import faq from './blocks/acf/faq';
import { heroHeading, initHeroSlider } from './blocks/acf/hero';
import { initSponsorsSlider } from './blocks/acf/sponsors';
import { initNewsSlider } from './blocks/acf/news';
import { initBranchSponsorsSlider } from './components/sliders';
import { initSliderSlider } from './blocks/acf/slider';
import accordionImageWithText from './blocks/acf/accordionImageWithText';
import { initWishesSlider } from './blocks/acf/wishes';
import support from './blocks/acf/support';
import donation from './components/donation';
import cookieConsent from './components/cookie-consent';

window.$ = window.jQuery = $;


Object.assign ( window, { Alpine: Alpine } );
Alpine.plugin ( persist );
Alpine.plugin ( collapse );
Alpine.plugin ( intersect );
Alpine.plugin ( focus );
Alpine.plugin ( ui );

$ ( () => {
  Alpine.data ( 'donation', donation );
  header ();
  gallery ();
  select ();
  modal ();
  cookieConsent ();
  accordionImages ();
  accordionImageWithText ();
  contactPeople ();
  faq ();
  initHeroSlider ();
  heroHeading ();
  support ();
  // donation ();
  initSponsorsSlider ();
  initSliderSlider ();
  initNewsSlider ();
  initWishesSlider ();
  initBranchSponsorsSlider ();

  $ ( '.swipebox' ).swipebox ();
  Alpine.start ();
} );
